export function removeLeadingZeros(time: string|undefined): string {
    if (!time) {
        return '';
    }
    return time.replace(/^00:/, '').replace(/^0(?!:)/, '');
}